import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import {Link} from 'react-router-dom';
var scrollToElement = require('scroll-to-element');


export default (props)=>(
  <div className={css.hero}>
    <div className={css.iphone_container}>
      <img alt="An Instagram Story of an happy dog in a swing." className={css.iphone} src={process.env.REACT_APP_URL+"/assets/iphone.png"}/>
    </div>
    <div className={css.main}>
      <h1>Analyze your Instagram Stories <br/> like a boss.</h1>
      <div className={css.buttons}>
        <button onClick={()=>scrollToElement('#features')} className={cn(css.why, css.pinkButton)}>Learn more</button>
        <Link to="/signup" className={cn(css.why, css.pinkButton, css.mainButton)}>Register now</Link>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/home_page/landing/sections/hero.js